<footer id="footer">
  <div id="sBeneficiosAdicionales" class="stellar-section">
    <div class="stellar-block overlap-wave-bottom">
      <div class="container">
        <div class="grid grid-nogutter">
          <div class="col-12 text-center p-4" [hidden]="hiddenTitle">
            <div
              class="text-2xl uppercase font-bold text-white"
              i18n="@@footer.title">
              <span class="inline-block">Consultores SegurSub</span>
            </div>
          </div>
        </div>

        <div class="grid grid-nogutter">
          <div class="col-12 grid grid-nogutter justify-content-around">
            <div class="text-center md:text-left p-4">
              <div class="max-w-25rem lg:max-w-full m-auto">
                @if (locale !== 'de'){
                <p class="uppercase poppins title" i18n="@@footer.address">
                  Dirección y teléfono
                </p>

                <!-- <div class="flex justify-content-start align-items-start">
                  <i class="ph ph-map-pin mr-2"></i>
                  <span class="pr-2">Av. Comte Sallent</span>
                  <span>Palma, Islas Baleares, España</span>
                </div> -->

                <div class="flex justify-content-start align-items-start">
                  <i class="ph ph-map-pin mr-2"></i>
                  <div class="text-left">
                    <span class="pr-2" i18n="@@footer.address.line1"
                      >Avenida Comte de Sallent, 29
                    </span>
                    <br />
                    <span i18n="@@footer.address.line2"
                      >Entresuelo D - 07003 - Palma</span
                    >
                    <br />
                    <span i18n="@@footer.address.line3"
                      >Islas Baleares, España</span
                    >
                  </div>
                </div>
                <br />

                <div
                  class="flex justify-content-start flex-wrap align-items-center">
                  <i class="ph ph-phone mr-2"></i>
                  <a href="tel:+34971695592">+34 971 695 592</a>
                </div>
                <br />
                } @else {
                <p class="uppercase poppins title" i18n="@@footer.address">
                  Dirección y teléfono
                </p>
                }
                <div class="flex justify-content-start align-items-center">
                  <i class="ph ph-envelope mr-2"></i>
                  <span>scubamedic&#64;segursub.com</span>
                </div>
              </div>
            </div>

            <div class="text-center md:text-left p-4 mb-4">
              <p class="uppercase poppins title" i18n="@@footer.social.title">
                Redes sociales:
              </p>
              <p i18n="@@footer.social.text">
                Siganos en nuestras redes sociales
              </p>
              <a
                data-hover="Facebook"
                href="https://www.facebook.com/p/Scubamedic-Europe-100054558484322/"
                target="_blank"
                class="sm-link">
                <i class="ph ph-facebook-logo fa-lg"> </i>
              </a>
              <!-- &nbsp;&nbsp;
              <a
                data-hover="Instagram"
                href="https://www.instagram.com/"
                target="_blank"
                class="sm-link"
                ><i class="ph ph-instagram-logo fa-lg"></i
              ></a> -->
            </div>
          </div>
        </div>

        <div class="grid grid-nogutter mt-4">
          <div class="grid col-12 p-4">
            <!-- <div class="col-12 md:col-4">
              <p>
                <a
                  href="https://scubamedic.com/ViewAnnualPolicy.php"
                  target="_blank">
                  <p-button
                    icon="ph ph-download"
                    label="Resumen de coberturas" />
                </a>
              </p>
              <div
                class="flex w-full flex-column align-items-center justify-content-between gap-4">
                <div class="flex gap-4">
                  <a
                    href="https://scubamedic.com/ViewAnnualPolicy.php"
                    target="_blank">
                    <img
                      alt="flag"
                      src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      class="flag flag-es w-3rem mr-3"
                      style="width: 18px" />
                  </a>

                  <a
                    href="https://scubamedic.com/ViewAnnualPolicy.php"
                    target="_blank">
                    <img
                      alt="flag"
                      src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      class="flag flag-ct w-3rem mr-3"
                      style="width: 18px" />
                  </a>

                  <a
                    href="https://scubamedic.com/ViewAnnualPolicy.php"
                    target="_blank">
                    <img
                      alt="flag"
                      src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      class="flag flag-uk w-3rem mr-3"
                      style="width: 18px" />
                  </a>
                </div>

                <div class="flex gap-4">
                  <a
                    href="https://scubamedic.com/ViewAnnualPolicy.php"
                    target="_blank">
                    <img
                      alt="flag"
                      src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      class="flag flag-de w-3rem mr-3"
                      style="width: 18px" />
                  </a>

                  <a
                    href="https://scubamedic.com/ViewAnnualPolicy.php"
                    target="_blank">
                    <img
                      alt="flag"
                      src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      class="flag flag-fr w-3rem mr-3"
                      style="width: 18px" />
                  </a>

                  <a
                    href="https://scubamedic.com/ViewAnnualPolicy.php"
                    target="_blank">
                    <img
                      alt="flag"
                      src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      class="flag flag-pt w-3rem mr-3"
                      style="width: 18px" />
                  </a>
                </div>
              </div>
            </div> -->
          </div>

          <div
            class="col-12 flex flex-column align-items-center justify-content-center mb-4"
            [hidden]="hiddenLogo">
            <!-- <img
              src="assets/img/logotipos/logo.webp"
              alt="Consultores SegurSub Logo"
              class="logotipo" />
            <span class="text-2xl">Consultores SegurSub</span> -->
          </div>

          <div class="col-12 text-sm p-4">
            <a
              href="aviso-legal"
              class="no-link-style"
              i18n="@@footer.links.legal-warning"
              >Aviso legal</a
            >
            |
            <a
              href="cookies"
              class="no-link-style link"
              i18n="@@footer.links.cookies">
              Política de cookies
            </a>

            <!-- <a
              href="politica-cancelacion"
              class="no-link-style link"
              i18n="@@footer.links.cancellation_policy">
              Política de cancelación
            </a>
            | -->
            <!-- <a
              href="privacidad"
              class="no-link-style"
              i18n="@@footer.links.privacy">
              Política de privacidad
            </a>
            | -->
            <!-- <a href="terminos" class="no-link-style" i18n="@@footer.links.terms"
              >Términos y condiciones</a
            >
            | -->
            @if (locale !== 'de') { |
            <a
              href="login"
              class="no-link-style"
              i18n="@@footer.links.private_access">
              Acceso privado
            </a>
            }

            <div
              class="text-sm"
              i18n="@@footer.text.registered_insurance_broker">
              <p>Consultores Segursub S.L. correduría de seguros.</p>

              <p>
                Concertado Seguro de Responsabilidad Civil y acreditada
                capacidad financiera según art. 157 RD Ley 3/2020, de 4 de
                febrero Nº Reg. DGSFP J-4505.
              </p>
              <!-- <p class="info wow fadeInUp" data-wow-delay=".4s">
                <span id="copyright-year"
                  >Consultores SegurSub S.L. © 2024.</span
                >
                <span i18n="@@footer.texts.rights"
                  >Todos los derechos reservados</span
                >
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<p-scrollTop />
